import axios from "axios";
import config from "../config/config";
import { handleApiError } from "../utils/errorHandler";

const BASE_URL = `${config.apiUrl}/api/food`;

export const foodService = {
  async listFoods() {
    try {
      const response = await axios.get(`${BASE_URL}/list`);
      console.log("Respuesta del servicio de comidas:", response.data);
      return {
        success: true,
        data: response.data.data || [],
        message: response.data.message || "Productos obtenidos exitosamente",
      };
    } catch (error) {
      console.error("Error en listFoods:", error);
      const apiError = handleApiError(error);
      return {
        success: false,
        data: [],
        message: apiError.message,
      };
    }
  },

  filterProducts(products, searchTerm, activeSection = null) {
    if (!products) return [];
    let filtered = [...products];

    if (searchTerm && searchTerm.length >= 2) {
      filtered = filtered.filter(
        (product) =>
          product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          product.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (activeSection) {
      filtered = filtered.filter((product) =>
        activeSection === "comidas"
          ? product.destination === "cocina"
          : product.destination === "barra"
      );
    }

    return filtered;
  },

  createFood: async (foodData) => {
    try {
      const response = await axios.post(`${BASE_URL}/create`, foodData);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  updateFood: async (id, foodData) => {
    try {
      const response = await axios.put(`${BASE_URL}/${id}`, foodData);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  deleteFood: async (id) => {
    try {
      const response = await axios.delete(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  getFoodById: async (id) => {
    try {
      const response = await axios.get(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  getFoodByCategory: async (categoryId) => {
    try {
      const response = await axios.get(`${BASE_URL}/category/${categoryId}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Función para obtener productos por categoría
  getProductsByCategory(products, categoryId) {
    if (!products || !categoryId) return [];
    return products.filter((product) => product.category === categoryId);
  },
};
